import { createClient } from '@supabase/supabase-js';
import { ENV, validateEnv } from '../config/env.ts';

if (!validateEnv()) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

const supabaseUrl = ENV.SUPABASE_URL;
const supabaseAnonKey = ENV.SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: window.localStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
